var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "form",
      {
        attrs: { id: _vm.formId },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.formSubmit.apply(null, arguments)
          },
        },
      },
      [
        _vm.rm.FormBlurb
          ? _c("p", { staticClass: "lead" }, [_vm._v(_vm._s(_vm.rm.FormBlurb))])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [
            _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
            _vm._v(" " + _vm._s(_vm.rm.AlternativeLabel) + " Name"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.rm.AlternativeName,
                expression: "rm.AlternativeName",
                modifiers: { trim: true },
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              readonly: _vm.rm.IsNameReadonly,
              required: "",
            },
            domProps: { value: _vm.rm.AlternativeName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.rm, "AlternativeName", $event.target.value.trim())
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.nameError))]),
        ]),
        _vm._v(" "),
        _vm.rm.IsDescriptionVisible
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Description")]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.rm.AlternativeDescription,
                    expression: "rm.AlternativeDescription",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control",
                attrs: { readonly: _vm.rm.IsDescriptionReadonly },
                domProps: { value: _vm.rm.AlternativeDescription },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.rm,
                      "AlternativeDescription",
                      $event.target.value.trim()
                    )
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.rm.IsStatusVisible
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Status:")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rm.AlternativeStatusId,
                      expression: "rm.AlternativeStatusId",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    readonly: _vm.rm.IsStatusReadonly,
                    disabled: _vm.rm.IsStatusReadonly,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.rm,
                        "AlternativeStatusId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                _vm._l(_vm.rm.Statuses, function (s) {
                  return _c("option", { domProps: { value: s.Id } }, [
                    _vm._v(_vm._s(s.Name)),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.rm.Sections, function (s) {
          return _c("div", { key: s.Name }, [
            s.Name
              ? _c("h5", [
                  _c(
                    "a",
                    {
                      staticClass: "text-primary",
                      on: {
                        click: function ($event) {
                          s.IsExpanded = !s.IsExpanded
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-angle-right",
                        class: { "fa-angle-down": s.Expanded },
                      }),
                      _vm._v(" " + _vm._s(s.Name) + "\n                "),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            s.IsExpanded
              ? _c(
                  "div",
                  _vm._l(s.Attributes, function (f) {
                    return _c(
                      "div",
                      { key: f.Id },
                      [
                        f.FieldType === "DateInputSingleValue"
                          ? _c("DateInputSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "DateInputMultiValue"
                          ? _c("DateInputMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "DateListSingleValue"
                          ? _c("DateListSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "DateListMultiValue"
                          ? _c("DateListMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "EmailInputSingleValue"
                          ? _c("EmailInputSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "EmailInputMultiValue"
                          ? _c("EmailInputMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "EmailListSingleValue"
                          ? _c("EmailListSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "EmailListMultiValue"
                          ? _c("EmailListMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "NumberInputSingleValue"
                          ? _c("NumberInputSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "NumberInputMultiValue"
                          ? _c("NumberInputMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "NumberListSingleValue"
                          ? _c("NumberListSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "NumberListMultiValue"
                          ? _c("NumberListMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "NumberCalculatedSingleValue"
                          ? _c("NumberCalculatedSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "TextInputSingleValue"
                          ? _c("TextInputSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "TextInputMultiValue"
                          ? _c("TextInputMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "TextListSingleValue"
                          ? _c("TextListSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "TextListMultiValue"
                          ? _c("TextListMultiValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        f.FieldType === "TextMultilineSingleValue"
                          ? _c("TextMultilineSingleValue", {
                              attrs: { propF: f, propErrors: _vm.errors },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }